import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const Financial = () => {
  return (

    <>

      <TextWrapper>
            <h1 className='rolling-text' >Financials reports</h1>
            <h1 className='rolling-text' >Financials reports</h1>
            <h1 className='rolling-text' >Financials reports</h1>
            <h1 className='rolling-text' >Financials reports</h1>
            <h1 className='rolling-text' >Financials reports</h1>
            <h1 className='rolling-text' >Financials reports</h1>
      </TextWrapper>

    
    <Container>

      

      <Cards>

        <Card target='blank' href='./pdf/CGAF - AUDIT FY - 2024.pdf'>      

          <div className='imgContainer'>
            <img className='image' src="./images/reports/FY'24.jpg" alt="" />
          </div>

          <a target='blank' href='./pdf/CGAF - AUDIT FY - 2024.pdf'><h3>CGAF - Audit FY - 2024</h3></a>

          <div className='link'>
            <a target='blank' href='./pdf/CGAF - AUDIT FY - 2024.pdf'>AUDIT FY - 2024</a>
            <div>
              <img className='arrow' src="./icons/arrow.png" alt="" />
            </div>
          </div>

        </Card>

        <Card target='blank' href='./pdf/CROSS GLOBAL ASIA FOUNDATION - Financial Report FY23.pdf'>      

          <div className='imgContainer'>
            <img className='image' src="./images/reports/4.jpg" alt="" />
          </div>

          <a target='blank' href='./pdf/CROSS GLOBAL ASIA FOUNDATION - Financial Report FY23.pdf'><h3>CGAF - Audit FY - 2022</h3></a>

          <div className='link'>
            <a target='blank' href='./pdf/CROSS GLOBAL ASIA FOUNDATION - Financial Report FY23.pdf'>AUDIT FY - 2022</a>
            <div>
              <img className='arrow' src="./icons/arrow.png" alt="" />
            </div>
          </div>

        </Card>

        <Card target='blank' href='./pdf/Cross Global Asia Foundation - FY 2022 - Audit Report.pdf'>      

          <div className='imgContainer'>
            <img className='image' src="./images/reports/2.jpg" alt="" />
          </div>

          <a target='blank' href='./pdf/Cross Global Asia Foundation - FY 2022 - Audit Report.pdf'><h3>CGAF - Audit FY - 2021</h3></a>

          <div className='link'>
            <a target='blank' href='./pdf/Cross Global Asia Foundation - FY 2022 - Audit Report.pdf'>AUDIT FY - 2021</a>
            <div>
              <img className='arrow' src="./icons/arrow.png" alt="" />
            </div>
          </div>

        </Card>

        <Card target='blank' href="./pdf/CGAF - Audit FY - 2020.pdf">

          <div className='imgContainer' >
            <img className='image' src="./images/reports/3.jpg" alt="" />
          </div>

          <a target='blank' href="./pdf/CGAF - Audit FY - 2020.pdf"><h3>CGAF - Audit FY - 2020</h3></a>

          <div to='' className='link'>
            <a target='blank' href="./pdf/CGAF - Audit FY - 2020.pdf">AUDIT FY - 2020</a>
            <div>
              <img className='arrow' src="./icons/arrow.png" alt="" />
            </div>
          </div>
          
        </Card>
        


      </Cards>

    </Container>

    </>
  )
}

export default Financial

const Container = styled.div`
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  padding: 2rem 2rem;
  /* margin-top: 3rem; */
  margin-bottom: 8rem;
  
`

const Cards = styled.div`
  /* display: flex; */
  gap: 80px;
  justify-content: center;
  /* height: 70vh; */
  /* align-items: center; */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  

  @media (max-width:650px) {
    /* flex-direction: column; */
    gap: 40px;
    grid-template-columns: repeat(1, 1fr);
  }
  
`

const Card = styled.a`

  /* width: 50%; */
  /* overflow: hidden; */

  @media (max-width:650px) {
    border-bottom: 1px #00000053 solid;
    padding-bottom: 2rem;
  }

  .arrow{
    opacity: 0;
  }
  
   

  &:hover .image{
    transform: scale(1.05);
  }

  &:hover .arrow{
    transform: translateX(10px);
    opacity: 1;
  }

  &:hover {
    cursor: pointer;
  }


  .link{
    display: flex;
    gap: 15px;
    align-items: center;
    color: black;

    a{
      color: black;
    }

    div{
      img{
        width: 20px;
        transition: 0.3s all ease-in-out;
      }
    }
  }

  a{
    h3{
      font-size: clamp(1.5rem, 2.5vw, 4rem);
      padding: 1rem 0;
    }
    color: black;
  }
  
  p{
    font-size: clamp(1rem, 1vw, 1.5rem);
  }

  .imgContainer{
    width: 100%;
    border-radius: 9px;
    overflow: hidden;
    img{
      width: 100%;
      object-fit: cover;
      transition: 0.3s all ease-in-out;
      border-radius: 9px;
    }
  }

  

`


const TextWrapper = styled.div`

    display: flex;
    justify-content: flex-start;
    overflow: hidden;
    padding: 6rem 0;
    padding-bottom: 2rem;

    margin-top: 9rem;

    .rolling-text{
        
        font-size: clamp(3rem, 3vw, 5rem);
        color: #FDCB4A;
        white-space: nowrap;
        padding: .5rem 3rem;
        animation: move-rtl 6000ms linear infinite;
        text-transform: uppercase;
        
    }

    @keyframes move-rtl {
        0%{
            transform: translateX(0);
        }

        100%{
            transform: translateX(-100%);
        }
    }
`